import React from 'react';

import DropdownFilterForm from 'search/filters/base/DropdownFilterForm';
import {
  BASE_FILTER_FORM_PROP_NAMES,
  BaseFilterFormProps,
  FilterStyle,
} from 'search/filters/base/FilterFormConstants';
import {MultiValueFilter} from 'search/SearchConstants';
import {ButtonSize} from 'ui-library/buttons/Button';
import {OptionData} from 'ui-library/menus/MenuConstants';
import {capitalize} from 'util/NameUtil';
import pick from 'util/pick';
import {WorklistType, worklistTypeDisplayName} from 'worklists/WorklistConstants';

export interface WorklistTypeFilterFormProps extends BaseFilterFormProps {
  filter: MultiValueFilter;
  filterStyle: FilterStyle;
  onChangeFilter: (filter: MultiValueFilter) => void;
  onRemove?: () => void;
}

export default function WorklistTypeFilterForm(props: WorklistTypeFilterFormProps): JSX.Element {
  const skeletonProps = pick(props, ...BASE_FILTER_FORM_PROP_NAMES);

  // eslint-disable-next-line no-restricted-syntax
  const optionDatas: Array<OptionData> = Object.values(WorklistType)
    .sort()
    .map((t: WorklistType) => ({
      name: capitalize(worklistTypeDisplayName(t)),
      value: t,
    }));

  return (
    <DropdownFilterForm
      {...skeletonProps}
      buttonSize={ButtonSize.SMALL}
      filterStyle={props.filterStyle}
      onChangeValue={(value: Array<string>) => {
        props.onChangeFilter({...props.filter, value});
      }}
      optionDatas={optionDatas}
      isMulti={true}
      value={props.filter.value}
    />
  );
}
